import * as React from 'react';
import CSS from 'csstype';
import Header from './Header';
import Footer from './Footer';
import { useAppContext } from '../context/app';
import { Box, CircularProgress, Container, Typography } from '@mui/material';

const appContainer: CSS.Properties = {
    minHeight: "100vh",
    flexDirection: "column",
    display: "flex",
    flex: "1 1 auto",
};

const bodyContainer: CSS.Properties = {
    flexDirection: "column",
    display: "flex",
    flex: "1 0 auto",
};

function Layout(props: React.PropsWithChildren) {
    const appContext = useAppContext();

    return <Box style={appContainer}>
        <Header />
        <Box style={bodyContainer}>
            <Container maxWidth="lg">
                {(appContext.isLoading) &&
                    <Box p={2} display="flex" flexGrow="1" justifyContent="center" textAlign="center">
                        <Box my={5}>
                            <Typography variant="h4">Please wait...</Typography>
                            <CircularProgress />
                        </Box>
                    </Box>
                }
                {(!appContext.isLoading) &&
                    <>
                        {props.children}
                    </>
                }
            </Container>
        </Box>
        <Footer />
    </Box>
}

export default Layout;
